module.exports = __webpack_public_path__ + "img/honda-ScheduleService.60ca8a00.png";